import React from "react";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../../../redux/store";
import { useUscLabel } from "../../../../../utils/labels";
import UscBasketFees from "../UscBasketFees";
import { getFeeListSelector } from "../../../../../utils/externalPriceUtils";

const BasketAdditionalCosts = (): JSX.Element | null => {
    const excludedFeeList = useUscSelector(getFeeListSelector("excluded"), shallowEqual);
    const showExcludedFees = excludedFeeList.length > 0;
    const titleAdditionalTaxesAndCostsLabel = useUscLabel("uscBasketTitleAdditionalTaxesAndCosts");

    if (!showExcludedFees) return null;

    return <UscBasketFees feeType="excluded" title={titleAdditionalTaxesAndCostsLabel} />;
};

export default BasketAdditionalCosts;
